import React, {Component} from 'react';
import qs from 'qs';
import '../styles/listlicence.css';
import { list as listLicence, remove as removeLicence } from '../services/licenceService';
import {
  Box,
  Paper,
  Stack,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Chip,
  Tooltip
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

class Listlicence extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hits: [],
      isLoading: false
    };
    this.fetchStories = this.fetchStories.bind(this);
    this.delete = this.delete.bind(this);
  }

  componentDidMount() {
    const parsed = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
    this._isMounted = true;
    this.fetchStories(parsed.website_id);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchStories(website) {
    const parsed = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
    this.setState({ isLoading: true });
    listLicence(website || parsed.website_id)
      .then((result) => {
        if (!this._isMounted) return;
        this.setState({ hits: result || [], isLoading: false });
      })
      .catch(() => this.setState({ isLoading: false }));
  }

  delete(item) {
    removeLicence(item.website, item._id).then(() => this.fetchStories(item.website));
  }

  render() {
    const parsed = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
    const { hits } = this.state;

    return (
      <Box sx={{ p: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography variant="h6">Licences</Typography>
          <Button variant="contained" size="small" component={RouterLink} to={`/super-admin/Formlicence?website_id=${parsed.website_id}`}>
            Add
          </Button>
        </Stack>

        <Paper variant="outlined">
          <TableContainer sx={{ maxHeight: '70vh' }}>
            <Table size="small" stickyHeader sx={{ '& tbody tr:nth-of-type(odd)': { bgcolor: 'action.hover' } }}>
              <TableHead>
                <TableRow>
                  <TableCell>Max views</TableCell>
                  <TableCell>AI analyses / month</TableCell>
                  <TableCell>Commercial</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {hits.map((item) => (
                  <TableRow key={item._id} hover>
                    <TableCell>{item.max_views}</TableCell>
                    {/* B6_01 : analyses IA incluses au forfait (vide = valeur par défaut, forfait à saisir) */}
                    <TableCell>{item.ai_analyses_included ? item.ai_analyses_included : '—'}</TableCell>
                    <TableCell>
                      <Tooltip title={item.commercial || ''}>
                        <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 320 }}>
                          {item.commercial}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Chip size="small" label={item.active ? 'active' : 'deactive'} color={item.active ? 'success' : 'default'} />
                    </TableCell>
                    <TableCell align="right">
                      <Stack direction="row" spacing={1} justifyContent="flex-end">
                        <Button
                          size="small"
                          variant="outlined"
                          component={RouterLink}
                          to={`/super-admin/Formlicence?website_id=${item.website}&licence_id=${item._id}`}
                        >
                          Edit
                        </Button>
                        <Button size="small" variant="outlined" color="error" onClick={() => this.delete(item)}>
                          Delete
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
                {hits.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <Typography variant="body2" color="text.secondary">Aucune donnée</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    );
  }
}
export default Listlicence;